import '@quasar/extras/mdi-v5/mdi-v5.css';
import '@quasar/extras/roboto-font/roboto-font.css';
import 'quasar/dist/quasar.ie.polyfills';
import iconSet from 'quasar/icon-set/mdi-v5';

import './styles/quasar.scss';

import Vue from 'vue';

import {
  QField,
  Quasar,
  QLayout,
  QHeader,
  QDrawer,
  QPageContainer,
  QPage,
  QToolbar,
  QToolbarTitle,
  QBtn,
  QIcon,
  QList,
  QItem,
  QItemSection,
  QItemLabel,
  QAvatar,
  QInput,
  QCard,
  QCardSection,
  QCardActions,
  QImg,
  QCheckbox,
  QRadio,
  QBadge,
  QBtnGroup,
  QStepper,
  QStep,
  QStepperNavigation,
  QFooter,
  QMenu,
  ClosePopup,
  QSelect,
  QOptionGroup,
  Ripple,
  QRouteTab,
  QTab,
  QTabs,
  QTabPanel,
  QTabPanels,
  Notify,
  QDialog,
  QInnerLoading,
  QCarousel,
  QCarouselSlide,
  QForm,
  QTooltip,
  QBar,
  QSpace,
  QSpinnerHourglass,
  QSeparator,
  QTimeline,
  QTimelineEntry,
} from 'quasar';

Vue.use(Quasar, {
  config: {
    notify: {
      position: 'top-right',
      timeout: 2500,
      textColor: 'white',
      actions: [{ icon: 'mdi-close', color: 'white' }],
    },
  },
  components: {
    QField,
    QMenu,
    QStep,
    QFooter,
    QStepper,
    QStepperNavigation,
    QBtnGroup,
    QBadge,
    QRadio,
    QCheckbox,
    QImg,
    QCard,
    QCardSection,
    QCardActions,
    QLayout,
    QHeader,
    QDrawer,
    QPageContainer,
    QPage,
    QToolbar,
    QToolbarTitle,
    QBtn,
    QIcon,
    QList,
    QItem,
    QItemSection,
    QItemLabel,
    QAvatar,
    QInput,
    QSelect,
    QOptionGroup,
    QTabs,
    QTabPanel,
    QTabPanels,
    QTab,
    QRouteTab,
    QInnerLoading,
    QDialog,
    QCarousel,
    QCarouselSlide,
    QForm,
    QTooltip,
    QBar,
    QSpace,
    QSpinnerHourglass,
    QSeparator,
    QTimeline,
    QTimelineEntry,
  },
  directives: {
    ClosePopup,
    Ripple,
  },
  plugins: {
    Notify,
  },
  iconSet: iconSet,
});
